import { MasterPlanLocationFilter } from 'planning-portal-library/src/lib/core/domain';
import { Mapper } from '../../../../../core/base';
import { MasterPlanLocationFilterWebEntity } from './master-plan-location-filter-web-entity';

export class MasterPlanLocationFilterWebRepositoryMapper extends Mapper<
  MasterPlanLocationFilterWebEntity,
  MasterPlanLocationFilter
> {
  constructor() {
    super();
  }

  mapFrom(param: MasterPlanLocationFilterWebEntity): MasterPlanLocationFilter {
    return {
      id: param.id,
      filterValue: param.filterValue ? param.filterValue.split(',') : [],
      filterTypeId: param.filterTypeId,
      filterFieldId: param.filterFieldId,
      planContainerId: param.planContainerId,
      sequenceNumber: param.sequenceNumber
    };
  }

  mapTo(param: MasterPlanLocationFilter): MasterPlanLocationFilterWebEntity {
    return {
      id: param.id,
      filterValue: param.filterValue.join(","),
      filterTypeId: param.filterTypeId,
      filterFieldId: param.filterFieldId,
      planContainerId: param.planContainerId,
      sequenceNumber: param.sequenceNumber
    };
  }
}
